<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
    <loader v-show="loader" object="#29B3A6" color1="#29B3A6" color2="#17fd3d" size="4" speed="5" bg="#343a40" objectbg="#999793" opacity="80" name="spinning"></loader>
    <div class="col-12 mt-3 mb-0 pb-0">
                <v-alert type="info">
                  Faites vous payer avec un seul lien que se soit pour vos évènements professionnels, vos Fêtes ou concerts, la vente d'un produit ou le paiement d'un service. Avec un seul lien, recupérer votre argent. C'est juste très simple! 
                </v-alert>
            </div>
    <div class="col-12">
        <h4 class="">
           <v-icon>mdi-link-box-variant</v-icon> Intram Direct 
        </h4>
      <v-card elevation="0">
       <!-- Generation de lien de paiement pour multiple payment -->
       <div>
           <v-row>
             <div class="col-12">
                <div class=" pt-0 mt-0">
         <v-row >
        <v-col cols="12" lg="3" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-link</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Total Lien Directe:</div>
              <div style="font-weight: bold" class="text-uppercase">
                {{ all_link }}
                  </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-clock</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Total revenu Lien Directe:</div>
              <div style="font-weight: bold">
                {{ total_amount_link }} XOF
              </div>
            </div>
          </div>

        </v-card>
      </v-col>
    
       <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large style="color:green">mdi-shield-link-variant</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre de lien Clôturer:</div>
              <div style="font-weight: bold">
                {{ close_link }}
              </div>
            </div>
          </div>
        </v-card>
       </v-col>
        <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large style="color:blue">mdi-link-variant</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre de lien Actif:</div>
              <div style="font-weight: bold">
                {{ active_link }}
              </div>
            </div>
          </div>
        </v-card>
        </v-col>
        <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large style="color:orange">mdi-link-variant-off</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre de lien Inactif:</div>
              <div style="font-weight: bold">
                {{ inactive_link }}
              </div>
            </div>
          </div>
        </v-card>
        
      </v-col>
       <v-col  cols="12" lg="3" md="3" class="mt-0 pt-0">
        <v-card style="padding: 15px;padding-bottom: 0px;padding-top:0px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large style="color:darkred">mdi-link-variant-remove</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre de lien Archiver:</div>
              <div style="font-weight: bold">
                {{ archive_link }}
              </div>
            </div>
          </div>
        </v-card>
        
      </v-col>
      
    
    </v-row>
                </div>
                <template >
                  <v-row style="background: #f8f8f8;">
                    <v-toolbar flat >
                    <v-col cols="12" sm="4" lg="5" class="pl-0 ml-0 pt-0">
                      <v-text-field solo
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-col>
                      <v-spacer/>
                      <v-btn
                          color="dark"
                          light
                          class="mb-2 mr-2"
                          @click=" dialogknow = true"
                      >
                       <v-icon>mdi-dots-horizontal-circle</v-icon>  En savoir plus
                      </v-btn>
                     <v-btn
                          color="primary"
                          dark
                          class="mb-2 mr-2"
                          @click="dialogLinks = true"
                      >
                       <v-icon>mdi-link-variant-plus</v-icon>  Générer un lien
                      </v-btn>
                    </v-toolbar>
                  </v-row>
                </template>

                <v-tabs v-model="links_tabs" class="mt-4">
                  <v-tab @click="getFilter('all')">Tous</v-tab>
                  <v-tab @click="getFilter('actif')">Actifs</v-tab>
                  <v-tab @click="getFilter('inactif')">Inactif</v-tab>
                  <v-tab @click="getFilter('closed')">Clôturer</v-tab>
                  <v-tab @click="getFilter('archived')">Archiver</v-tab>
                </v-tabs>
                 <v-data-table
                  :headers="headers"
                  :items="links"
                  :search="search"
                  sort-by="label"
                  class="elevation-1"
                  :loading="loadings.links" 
                  loading-text="Chargement en cours...">
                <template v-slot:item._created_at="{item}">
                  {{ new Date(item._created_at).toLocaleDateString() }}
                </template>
                 <template v-slot:item._link="{item}">
                  <span v-if="!item._archive || item._status"><a :href="item._link" target="_blank" v-b-tooltip.hover :title="item._link">{{ limiText(item._link,24) }}</a> &nbsp;&nbsp; <v-icon v-b-tooltip.hover title="télécharger" @click="copieToClipboard(item._link)" small>mdi-content-copy</v-icon> </span>
                </template>
                <template v-slot:item._qr_code="{item}">
                  <a :href="item._qr_code" :download="item._reference+'.png'" target="_blank" v-b-tooltip.hover title="cliquez pour télécharger">
                    <v-img
                      :src="item._qr_code"
                      :lazy-src="item._qr_code"
                      max-width="40"
                      max-height="40"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </a>
                </template>
                <template v-slot:item._image="{item}">
                    <v-img
                      :src="item._image && item._image!=='null' ? image_base_link+''+item._image : '/images/money_collecte.jpg'"
                      :lazy-src="item._image && item._image!=='null'  ? image_base_link+''+item._image : '/images/money_collecte.jpg'"
                      max-width="40"
                      max-height="40"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                </template>
                <template v-slot:item._price="{item}">
                  {{ item._price+' XOF' }}
                </template>
                 <template v-slot:item._status="{item}">
                   <span class="badge badge-info" v-if="item._status && item._active && !item._archive">Actif</span>
                  <span class="badge badge-warning" v-if="!item._active && item._status && !item._archive">Inactif</span>
                  <span class="badge badge-success" v-if="!item._status && !item._archive">Clôturer</span>
                  <span class="badge badge-danger" v-if="item._archive">Archiver</span>
                </template>
                <template v-slot:item._payment_type="{item}">
                 <span class="badge badge-info" v-if="item._payment_type==='multi'">Paiement Multiple</span>
                 <span class="badge badge-primary" v-else>Paiement Unique</span>
                </template>
               
                 <template v-slot:item.actions="{ item }">
                  <div style="text-align:  center">
                      <router-link :to="{name: 'links_details', params: {details: item._id}}" class="btn btn-light btn-sm"> <v-icon small>mdi-file-eye-outline</v-icon> Consulter</router-link>
                  </div>
                </template>
                <template v-slot:no-data>
                  <span>{{ $t('users.no_users_found') }}</span>
                </template>
              </v-data-table>
              <div class="col-12 text-right" style="background : #f8f8f8">
                <v-pagination
                elevation="0"
                v-model="page"
                :length="total_pages"
                :total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="getIntramDirectLinks"
                ></v-pagination>
              <!-- product pagination -->
        </div>

          <v-dialog
              v-model="dialogLinks"
              persistent
              scrollable
              max-width="600px"
          >
      <v-card>
       
        <v-card-text class="mt-5">
          <h5 class="mb-4 mt-4">
            Configurer les informations du lien à générer
          </h5>
        <v-form ref="form">
          <fieldset v-show="step===1">
              <label> Quel type de lien de paiement souhaitez-vous générer ? :</label>
              <v-radio-group v-model="payment_type" row class="pt-0 mt-0">
                <v-radio label=" Paiement unique"  value="unique">
                </v-radio>
                <v-radio label=" Paiement Multiple" value="multi">
                </v-radio>
              </v-radio-group>
          
              <v-row>
                <div class="col-12">
                  <v-label>A quoi servira votre lien de paiement ? </v-label>
                  <v-autocomplete auto-select-first solo  v-model="utility" :items="utilities" label="Cliquez pour faire un choix"></v-autocomplete>
                </div>
              </v-row>
              
              <v-row>
                  <div class="col-12 col-lg-8">
                      <v-label>Nom du produit <v-icon small>mdi-help-circle-outline</v-icon> ? </v-label>
                      <v-text-field v-model="label" :rules="requiredRules" solo label="Le nom"></v-text-field>
                  </div>
                    <div class="col-12 col-lg-4">
                      <v-label>Montant à payer </v-label>
                      <v-text-field type="number" required :rules="requiredRules" suffix="XOF" solo v-model="price" label="Le montant"></v-text-field>
                  </div>
              </v-row>
              
              <v-row>
                  <div class="col-12 col-lg-8">
                      <v-checkbox
                      class="mt-0 pt-0 mb-0 pb-0"
                        v-model="fees_support"
                        label="Supporter les frais de transaction"
                      ></v-checkbox>
                  </div>
              </v-row>

              <v-row>
                  <div class="col-12">
                      <v-label>Lien du paiement <v-icon small>mdi-help-circle-outline</v-icon>  </v-label>
                      <v-text-field type="text" :prefix="gateway_base_link+'/'+unique_id" solo
                        append-icon="mdi-square-edit-outline"
                        :class="link_textBox_status ? 'readOnlyTextBox' : ''"
                        @click:append="updateLinkData"
                        :readonly="link_textBox_status"
                        :rules="requiredRules"
                      v-model="link"></v-text-field>
                      <label class="link-data">{{gateway_base_link+'/'+unique_id+formated_link}}</label>
                  </div>
              </v-row>
          </fieldset>

          <fieldset v-show="step===2">
            <v-row>
                <div class="col-12">
                  <v-label> Description (Cette information apparaîtra sur la page de paiement) ? </v-label>
                  <v-textarea
                      solo
                      rows="2"
                      label="Description"  v-model="description"></v-textarea>
                </div>
                <div class="col-12">
                  <v-label>Logo ou image du produit </v-label>
                  <v-file-input accept="image/png, image/jpeg" :rules="imagerules" ref="image" solo show-size v-model="image"></v-file-input>
                </div>
                <div class="col-12 col-lg-6">
                  <v-label>Lien vers les détails du produit </v-label>
                  <v-text-field v-model="product_detail_link" solo label="exp:https://intram.org"></v-text-field>
                </div>
                <div class="col-12 col-lg-6">
                  <v-label>Lien de redirection </v-label>
                  <v-text-field v-model="redirection_link" solo label="exp:https://intram.org"></v-text-field>
                </div>
              </v-row>
          </fieldset> 
        </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn
          v-if="step===2"
              color="secondary"
              @click="step = 1"
              :disabled="loadings.linksSaving"
          >
            précédent
          </v-btn>
          <v-btn
          :disabled="loadings.linksSaving"
              color="dark"
              @click="dialogLinks = false"
          >
            annuler
          </v-btn>
          <v-btn
              :disabled="!link || link==='' || !payment_type || payment_type==='' || !label  || label==='' || !price || price===''"
              color="primary darken-1"
              @click="step===1  ? step++ : saveLink()"
              :loading="loadings.linksSaving"
          >
           {{ step===1  ? 'Continuer' : 'Générer le lien' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Know more -->
        <v-dialog
              v-model="dialogknow"
              persistent
              scrollable
              max-width="600px"
          >
      <v-card>
       
        <v-card-text class="mt-5">
          <h5 class="mb-4 mt-4">
           <v-icon>mdi-information-outline</v-icon> A Savoir Sur Intram Direct 
          </h5>
         <v-row >
         <h6 class="col-lg-12 col-sm-12">
         Avec Itram Direct, faites-vous payer via WhatsApp, Facebook, Instagram et plus encore !
         Créez, dès aujourd’hui, un lien pour encaisser les paiements de service, de vente d’articles et de dons en provenance de vos partenaires et clients.
       </h6>
      
        <v-col lg="12" sm="12">
          <v-alert type="info" outlined>
            Chacun des paiements collectés pour vous par Intram Direct sont récupérables sous un délai de 03 jours.
          </v-alert>
          <v-alert type="info" outlined>
            Nous ne prélevons qu’une somme de 25 Fcfa par transaction réussie.
          </v-alert>
        </v-col>
       </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="dark"
              @click="dialogknow = false"
          >
            annuler
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
             </div>

           </v-row>
           
       </div>
       <v-col>
      
       </v-col>
      </v-card>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import {mapState} from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import {client} from "../../store/services/client";
import {env} from "../../../env";

export default {
  components: { GoToParams},
  label: "Customers",
  data() {
    return {
      loader:false,
      all_link: 0,
      active_link: 0,
      inactive_link: 0,
      archive_link: 0,
      close_link: 0,
      total_amount_link: 0,
      fees_support:false,
      links:undefined,
      links_tabs:'',
      description:'',
      redirection_link:'',
      image:[],
      product_detail_link:'',
      step:1,
      all_link:0,
      active_link:0,
      inactive_link:0,
      archive_link:0,
      close_link:0,
      unique_id:undefined,
      gateway_base_link: env.gateway,
      image_base_link: env.image_base_url,
      dialogknow:false,
      dialogLinks:false,
      payment_type:'unique',
      utility:'',
      label:'',
      link:'',
      formated_link:'',
      price:0,
      filter:{},
      link_textBox_status:true,
      page: 0,
      total_pages: 0,
      imagerules: [
        value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      ],
      requiredRules: [
        v => !!v || 'Ce champ est requis',
      ],
      loadings: {
        links: false,
        linksSaving: false,
      },
      lazy: false,
      valid: false,
      icon: '',
      errors: {},
      search: '',
      utilities: ["Evènement professionnels","Fêtes /concerts","Collect/Dons","Paiement de service","Vente d'articles",'Autres'],
      payment_types: ["Paiement Unique","Paiement Multiple"],
      editedIndex: -1,
      editedItem: {},
      user_role: '',
      actions_items: [
        {title: "Détails", avatar: 'mdi-eye'},
        {title: "Supprimer", avatar: 'mdi-delete'},
      ],
      headers: [
        {text: '', value: 'actions', sortable: false},
        {text: 'Status', value: '_status'},
        {text: 'QR', value: '_qr_code'},
        {text: 'Image', value: '_image'},
        {text: 'Libellé', value: '_label'},
        {text: 'Type de lien', value: '_payment_type'},
        {text: 'Montant', value: '_price'},
        {text: 'link', value: '_link'},
        {text: 'Date de création', value: '_created_at'},
      ],
    }
  },
  computed: {
    
  },
  mounted() {
    this.initialize();
    this.$store.dispatch('countries/getCountries').then(response => {
    });

  },
  methods: {
    editItemAction(item, index) {
      switch (index) {
        case 0:
           this.$router.push({name: 'links_details', params: {details: item._id}})
          break;
        case 1:
          break;
      }
    },
    updateLinkData(){
      this.link_textBox_status=false;
    },
    resetLinkform(){
      this.payment_type='unique'
      this.step=1
    },
    async saveLink() {
        this.loadings.linksSaving = true;
        let formData = new FormData();
        formData.append('_label', this.label);
        formData.append('_price', this.price);
        //this.image = this.$refs.image.files[0];
        formData.append('_fees_support', this.fees_support && this.fees_support===true ? true : false);
        formData.append('_image', this.image);
        formData.append('_utility', this.utility);
        formData.append('_description', this.description);
        formData.append('_payment_type', this.payment_type);
        formData.append('_link', this.gateway_base_link+'/'+this.unique_id+this.formated_link);
        formData.append('_link_slug', this.unique_id+this.formated_link);
        formData.append('_redirection_link', this.redirection_link);
        formData.append('_product_detail_link', this.product_detail_link);
         await client({
          method: 'post',
          url: '/payment/link/save',
          data: formData
        })
            .then((res) => {
              if(res.data && !res.data.error){
                  this.$refs.form.reset();
                  this.resetLinkform()
                  this.dialogLinks = false;
                  this.loadings.linksSaving=false
                  this.toast('success', res.data.message)
                  this.getIntramDirectLinks();
              }else{
                  this.toast('error', res.data.message)
                   this.dialogLinks = false;
                  this.loadings.linksSaving=false
              }
            })
            .catch(error => {
               this.toast('error', error)
               this.dialogLinks = false;
               this.loadings.linksSaving=false
              return {
                error: "true"
              }
            })
        
    },
    async getIntramDirectLinks(page=1) {
      this.loadings.links = true
      page=page-1;
      const response = await client({
        method: 'post',
        url: `/payment/link/get/all`,
        data: {page:page, filter:this.filter}
      })
          .then(res => res.data)
          .catch(error => {
            console.log(error)
            this.loadings.links = false
            return {
              error: true
            }
          })
      this.loadings.links = false
      if (response && !response.error)
         this.links = response.paymentLinks
         this.page=response.page+1;
         this.total_pages = response.total_pages
    },
    async getIntramDirectLinkStats() {
      this.loadings.links = true
      this.loader=true;
      const response = await client({
        method: 'get',
        url: `/payment/link/stats`,
      })
          .then(res => res.data)
          .catch(error => {
            console.log(error)
            this.loadings.links = false;
            this.loader=false;
            return {
              error: true
            }
          })
      this.loadings.links = false
      this.loader=false;
      if (response && !response.error)
            this.all_link=response.all_link
            this.active_link=response.active_link
            this.inactive_link=response.inactive_link
            this.archive_link=response. archive_link
            this.close_link=response.close_link;
            this.total_amount_link=response.total_amount_link;
            this.getIntramDirectLinks();
    },
   async getFilter(filter_type='all') {
     let filter = {};
     switch(filter_type){
       case 'actif':
        filter = {_status: true, _archive: false, _active: true}
       break
       case 'inactif':
        filter = {_status: true, _archive: false, _active: false}
       break
       case 'closed':
         filter = {_status: false, _archive: false}
       break
       case 'archived':
         filter = { _archive: true}
       break
       default:
         filter = {}
        break
     }
     this.filter=filter;
     this.getIntramDirectLinks()
    },
   initialize() {
     this.getIntramDirectLinkStats()
   },
   checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
  },
  created() {
    ///intram/direct/:details
    this.checkisDashboard();
    this.initialize()
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogLinks() {
      this.unique_id= this.gMakeid(6)
    },
    label(val){
      if(val && val!==null){
      this.link=val
      this.formated_link=val
                          .toLowerCase()
                          .trim()
                          .replace(/[^\w\s-]/g, '')
                          .replace(/[\s_-]+/g, '_')
                          .replace(/^-+|-+$/g, '');
      }
    },
    link(val){
      if(val && val!==null){
      this.formated_link= val
                          .toLowerCase()
                          .trim()
                          .replace(/[^\w\s-]/g, '')
                          .replace(/[\s_-]+/g, '_')
                          .replace(/^-+|-+$/g, '');
      }
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

}
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
.link-data{
  font-weight: bold;
}
.readOnlyTextBox{
  background: gainsbo
}
</style>
